<template>
  <div id="overlapped-header" class="text-light" :style="{background: bgTheme, height: headerHeight}">
    <div class="page-title align-hor center-ver space-between" :style="{background: bgTheme}">
      <div class="align-hor center-ver">
        <div>
          <img class="medium-icon pull-left margin-10 pointer" src="@/assets/back-light.png" v-if="backButtonVisible" v-on:click="back">
          <div class="pull-left padding-10" v-else></div>
        </div>
        <div class="text-left text-large">{{getTranslatedText(headerTitle)}}</div>
      </div>
      <div class="credit align-ver center-ver margin-right-10" v-if="userHeaderBalance.show">
        <div class="wrap padding-5 radius-30 bg-light align-hor center-ver center-hor">
          <img class="smaller-icon pull-left margin-right-5" :src="userHeaderBalance.icon">
          <span class="text-grey margin-vertical-10 align-hor center-ver">{{userHeaderBalance.balance}}</span>
        </div>
      </div>
    </div>
    <div class="user-details" v-if="!model.onlyHeader">
      <div class="uname text-large margin-bottom-20" :style="{visibility: userName == 'User' ? 'hidden' : 'visible' }">Hello {{userName}}</div>
      <div class="ulevel align-hor center-ver margin-bottom-10 text-semi-small" v-if="isGamification">
        <div class="icon-wrapper padding-5 radius50 bg-light align-hor center-ver center-hor margin-right-5" v-if="userCurrLevelIcon"><img class="smaller-icon pull-left" :src="userCurrLevelIcon"></div>
        <div class="icon-wrapper padding-5 radius50 bg-light align-hor center-ver center-hor margin-right-5" v-else><img class="smaller-icon pull-left" src="@/assets/medal.svg"></div>
        <div>{{userCurrLevel}}</div>
      </div>
      <div class="ucredits align-hor space-between" style="justify-content: flex-end;">
        <div class="credits align-hor center-ver" v-if="model.referrals" style=" width: 100%; overflow-x: auto; white-space: nowrap; padding-right: 5px;">
          <div class="credit align-ver center-ver margin-right-10" v-for="urb in userReferralBalances">
            <div class="wrap padding-5 radius-30 bg-light align-hor center-ver center-hor margin-bottom-5">
              <img class="smaller-icon pull-left margin-right-5 margin-left-10" v-if="urb.reward_icon" :src="urb.reward_icon">
              <span class="text-grey margin-vertical-10 align-hor center-ver" style="margin-left: 2px !important;">{{formatReward(urb.reward_type, urb.balance, false)}}</span>
            </div>
            <div style="padding-top: 2px">{{urb.reward_type}}</div>
          </div>
        </div>
        <div class="credits align-hor center-ver" v-else-if="showCurrencyList" style=" width: 100%; overflow-x: auto; white-space: nowrap; padding-right: 5px;">
          <div class="credit align-ver center-ver margin-right-10 pointer" v-for="ub in userBalances" @click="redirectTo('transactions', {type: ub.reward_type, is_redeemable: ub.is_redeemable})">
            <div class="wrap padding-5 radius-30 bg-light align-hor center-ver center-hor">
              <img class="smaller-icon pull-left margin-right-5 padding-left-5" :src="ub.reward_icon">
              <span class="text-grey margin-vertical-10 align-hor center-ver" style="margin-left: 2px !important;">{{formatReward(ub.reward_type, ub.balance, false)}}</span>
              <img class="super-small-icon" src="@/assets/right-arrow.svg" v-if="!model.referrals">
            </div>
            <div v-if="showCurrencyName" class="padding-top-5">{{ub.reward_type}}</div>
          </div>
        </div>
        <div v-if="showActionButton">
        <div v-if="useWallet" style="margin-top:5px">
          <div style="margin-left: 15px" class="border-light padding-0510 radius-30 start-align-self pointer" v-if="!model.referrals">
            <div class="wrap align-hor center-ver center-hor margin-vertical-10" v-if="model.rewards" @click="redirectTo('wallet')">
              <img class="smaller-icon pull-left margin-right-5" src="@/assets/wallet-o.svg"> Wallet
            </div>
            <div class="wrap align-hor center-ver center-hor margin-vertical-10" v-else @click="redirectTo('rewards')">
              <img class="smaller-icon pull-left margin-right-5" src="@/assets/reward-o.svg"> Rewards
            </div>
          </div>
        </div>
        <div v-else style="margin-top:5px">
          <div style="margin-left: 15px" class="border-light padding-0510 radius-30 start-align-self pointer" v-if="!model.referrals && !model.rewards && showActionButton">
            <div class="wrap align-hor center-ver center-hor margin-vertical-10" @click="redirectTo('rewards')">
              <img class="smaller-icon pull-left margin-right-5" src="@/assets/reward-o.svg"> Rewards
            </div>
          </div>
        </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
  import { globals } from "@/mixins/globals"
  import axios from "axios"
  import Header from '@/components/header'
  export default {
    mixins: [globals],
    props: {
      model: Object
    },
    components: {
      'custom-header': Header
    },
    data() {
      return {
      }
    },
    computed: {
      headerHeight () {
        if (this.referralWalletData || this.$route.path != "/referrals") {
          return "250px";
        } else {
          return "200px";
        }
      }
    },
    beforeMount() {
      this.loadDataFromCookie();
      this.getFlyyAppinfov1();
    },
    methods: {
      getCookie(name) {
        var nameEQ = name + "=";
        var ca = document.cookie.split(';');
        for(var i=0;i < ca.length;i++) {
            var c = ca[i];
            while (c.charAt(0)==' ') c = c.substring(1,c.length);
            if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
        }
        return null;
      },

    },
    created() {
    }
  }
</script>
<style>
  #overlapped-header {
    height: 250px;
    text-align: left;
  }
  .user-details {
    padding: 64px 15px 0px;
  }
  .page-title {
    height: 64px;
    position: fixed;
    left: 0;
    right: 0;
    margin: auto;
    z-index: 2;
  }
  .icon-wrapper {
    height: 15px;
    width: 15px;
  }
  .credit .wrap {
    min-width: 50px;
  }
</style>



// WEBPACK FOOTER //
// src/components/overlapped-header.vue